// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
// RxJS
import { Subject } from 'rxjs';
import { RegisterModel } from './register.model';
import { ToastrService } from 'ngx-toastr';
import { AuthattorneyService } from '../../../../../../src/app/core/auth/_services/authattorney.service';

@Component({
	selector: 'kt-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit, OnDestroy {
	registerForm: FormGroup;		
	registerModel = new RegisterModel();
	loading = false;
	errors: any = [];
	PreferredValueArr: any = [{ 'value': '', 'key': 'Select Please' },{ 'value': 'email', 'key': 'Email' }, { 'value': 'fax', 'key': 'Fax' }];
	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param router: Router
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 */
	constructor(		
		private toastr: ToastrService,
		private auth: AuthattorneyService,
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef
	) {
		this.unsubscribe = new Subject();
	}

	/*
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
    */

	/**
	 * On init
	 */
	ngOnInit() {
		// this.initRegisterForm();
	}

	/*
    * On destroy
    */
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}
	/**
	 * Form Submit
	 */
	submit(registerForm) {
		if (registerForm.form.valid) {			
			this.auth.register(this.registerModel).subscribe((res)=>{
				this.router.navigate(['auth/attorney/login']).then(() => {
					this.registerModel = new RegisterModel();
					this.toastr.success('Successfully Register', 'Success!');
				});
			},err=>{
				if (err) {
					this.toastr.error('Something went wrong please try again', 'Error!');
				}
			});			
		}		
	}
}
